<template>
  <div id="wt-form" :class="{'hide-filter': !showFilter}" >
      <slot name="left" v-if="showFilter"></slot>
      <slot name="right"></slot>
  </div>
</template>

<script>
export default {
    name: 'wt-form',
    computed: {
        showFilter() {
            return this.$store.state.toolbars.showFilter;
        }
  },

}

</script>


